import { render, staticRenderFns } from "./ruleGroupForm.vue?vue&type=template&id=55cd9d1c"
import script from "./ruleGroupForm.vue?vue&type=script&lang=js"
export * from "./ruleGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports